import React from 'react';

/**
 * Единая кнопка закрытия для модалок главного меню сайдбара.
 * Стиль как в модалке «Общий календарь».
 */
export default function ModalCloseButton({ onClick, 'aria-label': ariaLabel = 'Закрыть', inline = false }) {
  const style = {
    fontSize: 28,
    background: '#f18181',
    border: '2px solid #000',
    cursor: 'pointer',
    color: '#000',
    fontWeight: 'bold',
    width: 36,
    height: 36,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    lineHeight: 1,
    ...(inline
      ? { position: 'static', flexShrink: 0, zIndex: 1 }
      : { position: 'absolute', top: 16, right: 16, zIndex: 10 })
  };

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      style={style}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = '#f52f2f';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = '#f18181';
      }}
    >
      ×
    </button>
  );
}
